module.exports = __webpack_public_path__ + "img/40-ABITO-RIBOLLA-SML-COLORI-LINO5.837ea672.jpg";